import Swiper, { Navigation, Pagination } from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/pagination';

import  Plyr from 'plyr';
import plyrSvg from '../images/plyr.svg';
import 'plyr/dist/plyr.css';

const activePlayers = [];

$(window).on('unblock-youtube', function(e) {
    // console.log('unblock-youtube', e);
    // if (e.detail === undefined) return;

    // setTimeout(() => {
    //     let playerId = $(e.detail).attr('id');
    //     // console.log('setTimeout player ', playerId);
    //     let p = new Plyr(`#${playerId}`, {
    //         iconUrl: plyrSvg,
    //         youtube: {
    //             noCookie: true, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1
    //         },
    //     });
    //     activePlayers.push(p);
    //     // console.log('activePlayers', activePlayers);
    // }, 500);

    const plyr = Plyr.setup('.bv-product-item__video', {
        iconUrl: plyrSvg,
        youtube: {
            noCookie: true, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1
        },
    } )

});


$(() => {

    const allSliders = [...$('.swiper-container:not(:has(.swiper-product-gallery,.swiper-product-video-gallery))')];
    allSliders.forEach((slider, index) => {

        let nextEl = slider.querySelector('.swiper-button-next'),
            prevEl = slider.querySelector('.swiper-button-prev'),
            paginationEl = slider.querySelector('.swiper-pagination'),
            swiperEl = slider.querySelector('.swiper-product-related');

        const swiperAll = new Swiper(swiperEl, {
            modules: [ Navigation, Pagination ],
            // direction: 'vertical',
            loop: false,
            slidesPerView: 1,
            spaceBetween: 27,
            lazy: {
                loadPrevNext: true,
            },
            // lazy: true,
            breakpoints: {
                480: {
                    slidesPerView: 2,
                    // spaceBetween:
                },
                600: {
                    slidesPerView: 2,
                    // spaceBetween:
                },
                1025: {
                    slidesPerView: 3,
                    // spaceBetween:
                },
                1200: {
                    slidesPerView: 4,
                    // spaceBetween:
                },
            },
            pagination: {
                el: paginationEl,
                type: 'bullets',
                clickable: true,
            },

            navigation: {
                nextEl: nextEl,
                prevEl: prevEl,
            },

        });
    });

    const gallerySlider = document.querySelector('.swiper-container .swiper-product-gallery');
    if ( gallerySlider ) {

        let gallerySliderContainer = gallerySlider.parentNode,
            nextEl = gallerySliderContainer.querySelector('.swiper-button-next'),
            prevEl = gallerySliderContainer.querySelector('.swiper-button-prev'),
            paginationEl = gallerySliderContainer.querySelector('.swiper-pagination');

        const gallerySwiper = new Swiper(gallerySlider, {
            modules: [ Navigation, Pagination ],
            // direction: 'vertical',
            focusableElements: 'input, select, option, textarea, button, video, label, iframe',
            loop: true,
            slidesPerView: 1,
            noSwipingClass: 'swiper-no-swiping',
            pagination: {
                el: paginationEl,
                type: 'bullets',
                clickable: true,
            },
            lazy: {
                loadPrevNext: true,
            },
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl,
            },
        });
    }

    // $('.swiper-product-video-gallery').get(0).addEventListener('unblock-youtube', function(e) {
    //     console.log("product unblock-youtube blocker");
    // });


    const videoSlider = document.querySelector('.swiper-container .swiper-product-video-gallery');
    if (videoSlider) {

        let videoSliderContainer = videoSlider.parentNode,
            nextEl = videoSliderContainer.querySelector('.swiper-button-next'),
            prevEl = videoSliderContainer.querySelector('.swiper-button-prev'),
            paginationEl = videoSliderContainer.querySelector('.swiper-pagination');

        const videoSwiper = new Swiper(videoSlider, {
            modules: [ Navigation, Pagination ],
            // direction: 'vertical',
            focusableElements: 'input, select, option, textarea, button, video, label, iframe',
            loop: false,
            slidesPerView: 1,
            noSwipingClass: 'swiper-no-swiping',
            pagination: {
                el: paginationEl,
                type: 'bullets',
                clickable: true,
            },
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl,
            },
        });

        videoSwiper.on('slideChangeTransitionEnd', () => {
            activePlayers.forEach((p) => {
                if (p.playing) {
                    p.pause();
                }
            });
        });
    }

});
